var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('div',{staticClass:"token-expired white-box"},[_c('div',{staticClass:"ico"},[_c('img',{attrs:{"src":require("@/assets/clock.png"),"alt":"Link expirado","width":"260px"}})]),_c('div',{staticClass:"txt a-center"},[_vm._v(" O seu Link de Pagamento expirou, entre em contato com o consultor responsável pela sua reserva. ")])])])
}]

export { render, staticRenderFns }